import React from 'react';
import noData from 'assets/img/product/nodatafound.png';

const Nodatafound = (props) => {
  const { title } = props;

  return (
    <div className="dark:bg flex w-full flex-col items-center justify-center rounded-[20px] md:py-12 lg:py-28 3xl:py-40">
      <img src={noData} className="color-white mt-4 w-[200px]" alt="Error" />
      <p className="mt-4 text-center text-sm font-bold text-navy-700 dark:text-white xl:mt-8 xl:text-lg">
        {title}
      </p>
    </div>
  );
};

export default Nodatafound;
